import React, { useState } from 'react';
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid
} from 'recharts';
import dayjs from 'dayjs';

const ChartWithTimeframe = ({ fullData }) => {
  const timeframes = {
    '1W': 7,
    '1M': 30,
    '3M': 90,
    '6M': 180,
    '1Y': 365,
    'ALL': null,
  };
  const [timeframe, setTimeframe] = useState('3M');

  // Convert and format burn to 2 decimal places
  const processedData = fullData.map(d => ({
    ...d,
    date: d.date, // keep as string or convert to dayjs if needed
    burn: parseFloat(parseFloat(d.burn).toFixed(2)), // 2 decimal places
  }));

  const filterData = () => {
    let filtered = timeframes[timeframe] === null
      ? processedData
      : processedData.filter(d =>
          dayjs(d.date).isAfter(dayjs().subtract(timeframes[timeframe], 'day'))
        );
    return filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const displayedData = filterData();

  const formatMillions = (value) => {
    if (value >= 1e6) return `${(value / 1e6).toFixed(2)}M`;
    if (value >= 1e3) return `${(value / 1e3).toFixed(2)}K`;
    return value.toFixed(2);
  };

  return (
    <div>
    <div style={{
      width: "100%",
      backgroundColor: "#111",
      borderRadius: 12,
      padding: 10,
      color: "#fff",
      gap: 10,
      alignItems: "center",
      position: "relative",
      overflow: "hidden"
    }}>
      <div className="d-flex justify-content-end flex-wrap gap-2">
        <div className="d-flex" style={{ marginBottom: 10 }}>
          <div className="rTabs">
            {Object.keys(timeframes).map(tf => (
              <button
                key={tf}
                onClick={() => setTimeframe(tf)}
                style={{
                  marginRight: 8,
                  padding: '6px 12px',
                  background: timeframe === tf
                    ? 'linear-gradient(94.35deg, #F8F192 0.05%, #E3D578 26.62%, #B18D38 56.99%, #9D721F 98.73%)'
                    : '',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 4,
                  cursor: 'pointer'
                }}
              >
                {tf}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div>
        <ResponsiveContainer width="100%" height={500}>
          <AreaChart data={displayedData}>
            <defs>
              <linearGradient id="colorBurn" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#FFD700" stopOpacity={0.6} />
                <stop offset="100%" stopColor="#121212" stopOpacity={0} />
              </linearGradient>
            </defs>
            {/* Add Cartesian Grid */}
            <CartesianGrid stroke="#333" strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={date => dayjs(date).format('DD MMM, YYYY')}/>
            <YAxis tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={formatMillions} label={{ value: 'PTGC', angle: -90, position: 'insideLeft', fill: '#ccc', offset: 30, dy: -30}}/>

            <Tooltip
              contentStyle={{ backgroundColor: '#333', border: 'none' }}
              labelStyle={{ color: '#fff' }}
              formatter={(burn, name) => {
                const formatted = `${parseFloat(burn).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                if (name === 'burn') return [formatted, 'Burn '];
                return [formatted, name];
              }}
              labelFormatter={label => `Date: ${dayjs(label).format('DD MMM, YYYY')}`}
            />
            <Area type="monotone" dataKey="burn" stroke="#FFD700" fillOpacity={1} fill="url(#colorBurn)"/>
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
    </div>
  );
};

export default ChartWithTimeframe;
